import React, { Component } from 'react';
import _ from 'lodash';
import { parseStringParam, dpath, shallowEqual } from '../../../utils/shared';
import { getDonorsFromFolder } from '../../../utils/donorHelpers';
import { connect } from 'react-redux';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import DonorFullPage from '../../../Components/Donor/DonorFullPage';
// import VerticalVideoSync from '../../containers/VerticalVideoSync';
class NewarkDonorListPassive extends Component {

  constructor(props) {
    super(props);
    this.state = {
      donorData: null,
      cycleIndex: 0,
      showDonors: true,
      showSlides: false,
      slideImage: "",
      parentCategoryName: "", //state based to support setting to empty string on fades
      subCategoryname: "",
      subCategorySubheader: "",
      subCategoryDescription: ""
    }
    this._categoryCurrent = -1;
    this._endOfDonorLoop = true;
    this._donors = null;
    this._manualSlidesIndex = 0; //which manual slide entry
    this._manualSlidesInnerIndex = -1; //which manual slide within entry

    //defaults
    this._columns = 3;
    this._rows = 8;
    this._fontColor = "#ffffff";
    this._backdropColor = "#000000";
    this._footerText = "";
    this._parentCategoryName = ""; //used to stash name so state can switch to empty string
    this._ni_options = {};
    this._metaCycleTimeout = null;
    this._listCycleTime = 8000;
    this._marginRight = this.props.screen.sv.width * 0.0375;

    this._parentCategoryNameStyle = {};
    this._subCategoryNameStyle = {};
    this._subCategorySubheaderStyle = {};
    this._subCategoryDescriptionStyle = {};
    this._nameListStyle = {};
    this._footerTextStyle = {};

    this._parentCategoryNameOffset = {};
    this._subCategoryNameOffset = {};
    this._subCategorySubheaderOffset = {};
    this._subCategoryDescriptionOffset = {};
    this._nameListOffset = {};
    this._footerTextOffset = {};
    this._titleDividerLineOffset = {};
    this._nameListHeight = 0;
    this._resetLoopOnStart = true;

    try {
      //safe overrides
      if (_.has(this.props.folder, 'contents.custom_fields')) {
        this._ni_options = this.props.folder.contents.custom_fields;
        const slides = _.get(this.props.folder.contents, 'arrays_values.slides', []);
        const manualSlides = slides.map(s => {
          return {
            screens: Number(s.screens.val),
            start: Number(s.start_slide.val),
            end: Number(s.end_slide.val),
          };
        });
        this._ni_options.manualSlides = manualSlides;
        this._ni_options.slideshow_module = this.props.otherModules[0];
        this._resetLoopOnStart = this._ni_options.reset_insertation_schedule_loop.val;
        this.setFontAttributes(this._parentCategoryNameStyle, this.props.folder.contents.custom_fields.parent_category_name);
        this.setFontAttributes(this._subCategoryNameStyle, this.props.folder.contents.custom_fields.subcategory_name);
        this.setFontAttributes(this._subCategorySubheaderStyle, this.props.folder.contents.custom_fields.subcategory_subheader);
        this.setFontAttributes(this._subCategoryDescriptionStyle, this.props.folder.contents.custom_fields.subcategory_description);
        this.setFontAttributes(this._nameListStyle, this.props.folder.contents.custom_fields.name_list);
        this.setFontAttributes(this._footerTextStyle, this.props.folder.contents.custom_fields.footer_text);
        this._sumH = Number(_.get(this.props.folder, 'contents.custom_fields.top_margin.val', 0)) * .01 * this.props.screen.screenHeight; //adjust for base offset
        this.setOffset(this._parentCategoryNameOffset, this.props.folder.contents.custom_fields.parent_category_name, 0);
        this.setOffset(this._subCategoryNameOffset, this.props.folder.contents.custom_fields.subcategory_name, 0);
        this.setOffset(this._subCategorySubheaderOffset, this.props.folder.contents.custom_fields.subcategory_subheader, 0);
        this.setOffset(this._subCategoryDescriptionOffset, this.props.folder.contents.custom_fields.subcategory_description, 0);
        this._titleDividerLineOffset.val = this._sumH;
        this.setOffset(this._nameListOffset, this.props.folder.contents.custom_fields.name_list, Number(this.props.folder.contents.custom_fields.divide_line_margin.val));
        this._footerTextOffset.val = this.props.screen.screenHeight - Number(_.get(this.props.folder.contents.custom_fields, 'footer_text.val', 0)) * .01 * this.props.screen.screenHeight;
      }
      if (_.has(this.props.folder, 'contents.custom_fields.columns.val')) {
        this._columns = Number(this.props.folder.contents.custom_fields.columns.val);
      }
      if (_.has(this.props.folder, 'contents.custom_fields.rows.val')) {
        this._rows = Number(this.props.folder.contents.custom_fields.rows.val);
      }
      if (_.has(this.props.folder, 'contents.custom_fields.fontColor.val')) {
        this._fontColor = this.props.folder.contents.custom_fields.fontColor.val;
      }
      if (_.has(this.props.folder, 'contents.custom_fields.background_color.val')) {
        this._backdropColor = this.props.folder.contents.custom_fields.background_color.val;
      }
      if (_.has(this.props.folder, 'contents.custom_fields.footer_text.val')) {
        this._footerText = this.props.folder.contents.custom_fields.footer_text.val;
      }
      if (_.has(this.props.folder, 'contents.custom_fields.cycle_timeout.val')) {
        this._listCycleTime = Number(this.props.folder.contents.custom_fields.cycle_timeout.val) * 1000;
      }
      if (_.has(this.props.folder, 'contents.custom_fields.column_spacing.val')) {
        this._marginRight = Number(this.props.folder.contents.custom_fields.column_spacing.val) * 0.01 * this.props.screen.r16_9.width;
      }
    } catch (e) {
      console.log(e);
    }
  }

  componentDidMount() {
    this.initDonors();
    document.addEventListener("keydown", this.handleKeyDown);
    this.metaCycle();
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    clearTimeout(this._metaCycleTimeout);
    this._metaCycleTimeout = null;
  }

  setOffset = (setVar, styleObj, margin) => {
    if (styleObj.visible === true) {
      setVar.val = this._sumH + (margin * .01 * this.props.screen.screenHeight);
      this._sumH += styleObj.height * .01 * this.props.screen.screenHeight;
    }
  }

  setFontAttributes = (styleObj, rootObj) => {
    styleObj.color = _.get(rootObj, 'fontColor', null);
    styleObj.fontWeight = _.get(rootObj, 'fontWeight', null);
    styleObj.textAlign = _.get(rootObj, 'justification', "left").toLowerCase();
    styleObj.fontStyle = _.get(rootObj, 'fontStyle', "normal").toLowerCase();
    styleObj.fontFamily = _.get(rootObj, 'font', "");
    styleObj.fontSize = _.get(rootObj, 'fontSize', 0) * this.props.screen.screenHeight * .01;
  }

  handleKeyDown = (e) => {
    switch (e.key) {
      case '1':
        this.metaCycle(true);
        break;
      case '6':
        clearTimeout(this._metaCycleTimeout);
        break;
      default:
        break;
    }
  }

  setMetaCycleTimeout(time, cycleIndex) {
    if (this._metaCycleTimeout) {
      clearTimeout(this._metaCycleTimeout)
      this._metaCycleTimeout = null
    }

    this._metaCycleTimeout = setTimeout(() => {
      this.metaCycle(cycleIndex);
    }, time)
  }

  //called for every cycle to determine action
  metaCycle = (cycleIndex) => {
    if (cycleIndex) {
      this.cycleIndex();
    }

    if (this._ni_options.interstitial.val === false) {
      this.cycleDonorIndex();
      this.setState({
        showDonors: true,
        showSlides: false
      })
      this.setMetaCycleTimeout(this._listCycleTime, true);
    } else {
      if (this._ni_options.auto_interstitial.val === true) {
        //TODO: Implement
        //insert per number of screens
        //this._ni_options.screensBetween;
      } else if (this._resetLoopOnStart === true && this._manualSlidesIndex > this._ni_options.manualSlides.length - 1) {
        this.setState({
          showDonors: true,
          showSlides: false
        })
        this.cycleDonorIndex();
        this.setMetaCycleTimeout(this._listCycleTime, true);
      } else {
        this._manualSlidesInnerIndex++;
        let slideData = this._ni_options.manualSlides[this._manualSlidesIndex];
        let totalSteps = slideData.screens + slideData.end - slideData.start;
        if (this._manualSlidesInnerIndex < slideData.screens) {
          this.cycleDonorIndex();
          this.setState({
            showDonors: true,
            showSlides: false
          })
          this.setMetaCycleTimeout(this._listCycleTime, true);
        } else if (this._manualSlidesInnerIndex <= totalSteps) {
          //cycle through and show slides
          let currentSlideIndex = (slideData.start - 1) + (this._manualSlidesInnerIndex - slideData.screens);
          let dd = this.state.donorData || {};
          dd.name = "";
          this.clearDonorData();
          this.setState({
            slideImage: dpath(this.props.screen.mode, this._ni_options.slideshow_module.contents.images[currentSlideIndex].path, this._ni_options.slideshow_module.contents.images[currentSlideIndex].file_name, this.props.screen.webkey),
            donorData: dd
          })
          let slideTimeOut = this._listCycleTime;
          if (_.has(this._ni_options, 'slideshow_module.contents.cycle_overrides[' + currentSlideIndex + ']')) {
            slideTimeOut = this._ni_options.slideshow_module.contents.cycle_overrides[currentSlideIndex] * 1000;
          }
          this.setMetaCycleTimeout(slideTimeOut, true);
        }
        else {
          this._manualSlidesIndex++;
          //if not resetLoopOnStart end of loop cycle slides
          if (this._resetLoopOnStart === false && this._manualSlidesIndex > this._ni_options.manualSlides.length - 1) {
            this._manualSlidesIndex = 0;
          }
          this._manualSlidesInnerIndex = -1
          this.metaCycle(false); //end of loop recursive
        }
      }
    }
  }

  clearDonorData = () => {
    this.setState({
      showSlides: true,
      showDonors: false,
      parentCategoryName: "",
      subCategoryName: "",
      subCategorySubheader: "",
      subCategoryDescription: "",
    })
  }

  initDonors = () => {
    const children = this.props.content.story_categories.filter(f => f.parent_category === this.props.folder.id);
    const sortedChildren = children.sort((a, b) => a.rank - b.rank);
    const grouppedDonors = sortedChildren.map(c => {
      const donors = getDonorsFromFolder(this.props.donors, this.props.content.folder_modules, c.id);
      c.donors = _.orderBy(donors, [donor => donor.sorting_name.toLowerCase()], ['asc']);
      return c;
    });

    this._donors = grouppedDonors;
    let cat = this._donors[0];
    let parent = this.props.folder;
    if (parent) {
      this._parentCategoryName = parent.description;
      this.setState({
        parentCategoryName: parent.description,
        subCategoryName: cat.description,
        subCategorySubheader: cat.subheader,
        subCategoryDescription: cat.description
      })
    }
  }

  shouldComponentUpdate(prevProps, prevState) {
    if (shallowEqual(this.state, prevState)) {
      return false;
    }
    return true;
  }

  //for unique transition keys
  cycleIndex = () => {
    let cycleIndex = this.state.cycleIndex;
    if (cycleIndex === 100) {
      cycleIndex = 0;
    }
    this.setState({
      cycleIndex: ++cycleIndex
    })
  }

  cycleSlideIndex = () => {
    let dd = this.state.donorData
    dd.name = "";
    this.clearDonorData();
    this.setState({
      donorData: dd
    })
  }

  cycleDonorIndex = () => {
    if (this._endOfDonorLoop === true) {
      this._categoryCurrent++;
      this._donorIndex = 0;
      if (this._categoryCurrent === this._donors.length) {
        //end of donor categories, reset entire loop
        this._categoryCurrent = 0;
        if (this._resetLoopOnStart === true) {
          this._manualSlidesIndex = 0; //which manual slide entry
          this._manualSlidesInnerIndex = -1; //which manual slide within entry
          //console.log("EXTRA LOOP");
          this._endOfDonorLoop = false;
          return this.metaCycle(false);
        }
      }
    }

    let total = this._columns * this._rows;
    let start = this._donorIndex * total;
    // USE THIS LOGIC FOR PARENT CATEGORY NAME
    let cat = this._donors[this._categoryCurrent];
    //set to static parent category name
    this.setState({
      parentCategoryName: this._parentCategoryName,
      subCategoryName: cat.description,
      subCategorySubheader: cat.subheader,
      subCategoryDescription: cat.description
    });

    if (!cat.donors[start]) {
      start = 0
      this._donorIndex = 0;
    }

    this._endOfDonorLoop = false;
    let end = start + (total);
    if (!cat.donors[end]) {
      end = cat.donors.length;
      this._endOfDonorLoop = true;
      this._donorIndex = 0;
    }
    else {
      this._donorIndex++
    }

    let donorsSliced = cat.donors.slice(start, end);
    let perColumn = 0;

    //distribute end page logic for empty units in last row
    if (this._endOfDonorLoop === true) {
      let dLength = donorsSliced.length;
      let extraSpaces = 0; //default to 0
      perColumn = Math.ceil(dLength / this._columns);
      if (perColumn * this._columns > dLength) { //extra spaces on last row required
        extraSpaces = (perColumn * this._columns) - dLength;
      }
      let normalSpaces = this._rows - perColumn //spaces to add on each normal row
      let lastSpaces = normalSpaces + extraSpaces //spaces to add on last row

      for (var i = 0; i < this._columns; i++) {
        if (i < (this._columns - 1)) { //rows prior to last
          for (var a = 0; a < normalSpaces; a++) {
            donorsSliced.splice((i * this._rows) + perColumn, 0, { name: "" });
          }
        } else {
          for (var b = 0; b < lastSpaces; b++) {
            donorsSliced.splice((i * this._rows) + perColumn, 0, { name: "" });
          }
        }
      }
    }
    this.setState({
      donorData: {
        donors: donorsSliced,
        name: cat.name
      }
    })

  }

  render() {
    if (!this.state.donorData) {
      return null
    }
    let sDims = {
      height: this.props.screen.sv.height,//1080,
      width: this.props.screen.sv.width//1920
    }
    let modifier = .6;
    sDims.fsTitle = sDims.height * 0.05556 * modifier; //60
    sDims.fsSubheader = sDims.height * 0.03333 * modifier; //36
    sDims.left = this.props.screen.sv.left

    // let debugBoxStyle = {
    //     position: 'absolute', 
    //     backgroundColor: 'black',
    //     opacity: .5,
    //     width: this.props.screen.screenWidth,
    //     height: this.props.screen.screenHeight / 2,
    //     top: 0,
    //     left: 0
    //  }

    return (
      <div className={this._fontClass} style={{ width: '100vw', height: '100vh', position: 'relative', color: this._fontColor, zIndex: 9999 }}>
        {/* <div style={debugBoxStyle} /> */}

        {/* Blue Backdrop */}
        <div style={{ position: 'absolute', left: sDims.left, top: 0, opacity: this._ni_options.background_opacity.val * .01, backgroundColor: this._backdropColor, width: sDims.width, height: sDims.height }} />

        {/* Title Divider Line*/}
        {this._ni_options.showTitleDivider ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.showDonors}>
              {this.state.showDonors ?
                <div style={{ position: 'absolute', left: sDims.width * .05 + sDims.left, top: this._titleDividerLineOffset.val, backgroundColor: this._fontColor, opacity: 1, width: sDims.width * .9, height: sDims.height * .0025 }} />
                :
                null}
            </div>
          </CSSTransitionGroup>
          :
          null}

        {/* Parent Category Name */}
        {this._ni_options.parent_category_name.visible ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.parentCategoryName} >
              <div style={{ ...this._parentCategoryNameStyle, position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._parentCategoryNameOffset.val, width: sDims.width * .9, height: sDims.height * .05 }}>
                <span>{this.state.parentCategoryName}</span>
              </div>
            </div>
          </CSSTransitionGroup>
          :
          null}

        {/* Sub Category Name */}
        {this._ni_options.subcategory_name.visible ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.subCategoryName} >
              <div style={{ ...this._subCategoryNameStyle, position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategoryNameOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }}>
                <span>{this.state.subCategoryName}</span>
              </div>
            </div>
          </CSSTransitionGroup>
          :
          null}

        {/* Sub Category Subheader */}
        {this._ni_options.subcategory_subheader.visible ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.subCategorySubheader} >
              <div style={{ ...this._subCategorySubheaderStyle, position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategorySubheaderOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }}>
                <span>{this.state.subCategorySubheader}</span>
              </div>
            </div>
          </CSSTransitionGroup>
          :
          null}

        {/* Sub Category Description */}
        {this._ni_options.subcategory_description.visible ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.subCategoryDescription} >
              <div style={{ ...this._subCategoryDescriptionStyle, position: 'absolute', left: sDims.left + sDims.width * 0.05, top: this._subCategoryDescriptionOffset.val, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }}>
                <span>{this.state.subCategoryDescription}</span>
              </div>
            </div>
          </CSSTransitionGroup>
          :
          null}

        {/* Slides */}
        <CSSTransitionGroup
          component='div'
          transitionName='slowfade'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.cycleIndex} >
            {this.state.showSlides ?
              <div style={{ position: 'absolute', left: sDims.left, top: 0, opacity: 1, width: sDims.width, height: sDims.height }}>
                <img alt={"Slide"} src={this.state.slideImage} style={{ width: sDims.width, height: sDims.height }} />
              </div>
              :
              null}
          </div>
        </CSSTransitionGroup>

        {/* Donor name lists */}
        {this._ni_options.name_list.visible ?
          <CSSTransitionGroup
            component='div'
            transitionName='slowfade'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.cycleIndex} >
              {this.state.showDonors ?
                <div style={{ ...this._nameListStyle, position: 'absolute', left: 0, top: 0, opacity: 1, width: sDims.width, height: sDims.height }}>
                  {/* Donor Names*/}
                  <div style={{ position: 'absolute', left: sDims.left + sDims.width * .05, top: this._nameListOffset.val, width: sDims.width * .9, height: sDims.height * .8 }}>

                    {this.state.donorData ? <DonorFullPage
                      fontclass={this._ni_options.name_list.font}
                      height={this._ni_options.name_list.height * .01 * this.props.screen.screenHeight}
                      width={sDims.width * .9}
                      rows={this._rows}
                      columns={this._columns}
                      donorData={this.state.donorData.donors}
                      screen={this.props.screen}
                      sort="column"
                      overrideFontSize={this._nameListStyle.fontSize}
                      overrideMarginRight={this._marginRight}
                      custom1x2={this.props.content.settings.custom_vars.custom1x2 ? true : false}
                      evenVerticalSpace={false}
                    /> : <span />}
                  </div>
                  {this._ni_options.footer_text.visible ?
                    <span style={{ ...this._footerTextStyle, left: sDims.width * .05 + sDims.left, marginRight: 0, position: 'absolute', width: sDims.width * .9, top: this._footerTextOffset.val }}>
                      <span>{this._footerText}</span>
                    </span>
                    :
                    null}
                </div>
                :
                null}
            </div>
          </CSSTransitionGroup>
          :
          null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let mod = state.content.dm_active[state.active_module];
  let isIdle = parseStringParam(window.location.href, "idle");
  if (isIdle === 'true') {
    mod = state.content.display_module_loops[0].display_module_loop_units[state.active_module].data; //.display_module.data
    mod = _.find(state.content.dm_active, { id: mod.id }); //TODO: should populate the module loop?
  }
  return {
    screen: state.screen,
    module: mod,
    donors: state.donors,
    content: state.content,
  };
};

export default connect(mapStateToProps, null)(NewarkDonorListPassive);


// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkDonorListsPassive.jsx